import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom/dist";
import { Col, Dropdown, Row } from "react-bootstrap";
import { CasinoProviders } from "../lib/data";

import ProviderLogo1 from "../assets/images/providers/Evolution.jpg";
import ProviderLogo2 from "../assets/images/providers/Ezugi.jpg";
import ProviderLogo3 from "../assets/images/providers/Supernowa.jpg";
import ProviderLogo4 from "../assets/images/providers/XPG.jpg";
import ProviderLogo5 from "../assets/images/providers/Vivogaming.jpg";
import ProviderLogo7 from "../assets/images/providers/OneTouch.jpg";
import ProviderLogo8 from "../assets/images/providers/Pragmaticplay.jpg";
import ProviderLogo9 from "../assets/images/providers/Onlyplay.jpg";

import Img1 from "../assets/images/icons/footer/casino-sigma-europe.webp";
import Img2 from "../assets/images/icons/footer/crypto-casino-affpapa.webp";
import Img3 from "../assets/images/icons/footer/mobile-sigma-africa.webp";
import Img4 from "../assets/images/icons/footer/platform-sigma-asia.webp";

import FootLogo1 from "../assets/images/icons/footer/sigma.webp";
import FootLogo2 from "../assets/images/icons/footer/responsible-gambling.webp";
import FootLogo3 from "../assets/images/icons/footer/gamcare.webp";
import FootLogo4 from "../assets/images/icons/footer/betblocker.webp";
import FootLogo5 from "../assets/images/icons/footer/plus.webp";
import FootLogo6 from "../assets/images/icons/footer/c9.webp";
import FootLogo7 from "../assets/images/icons/footer/leicester.png";
import FootLogo8 from "../assets/images/icons/footer/jason_derulo.webp";

import WhatsappIcon1 from "../assets/images/whatsapp.png";
import TelegramIcon from "../assets/images/Telegram.svg";
import InstaIcon from "../assets/images/Instagram.svg";
import Facebook from "../assets/images/facebook-512.svg";
import Calling from "../assets/images/phone-call.png";

import gcb from "../assets/images/icons/footer/gcb.webp";

import Menu from "../assets/images/icons/Menu-new.webp";
import Explore from "../assets/images/icons/Supports-new.webp";
import CasinoIcon from "../assets/images/icons/Casino-new.webp";
import SportsIcon from "../assets/images/icons/Sports-new.webp";
import Chat from "../assets/images/icons/searchfoot.webp";

import Facebook1 from "../assets/images/facebook-512.svg";
import WhatsappIcon12 from "../assets/images/Whatsapp.svg";
import Calling1 from "../assets/images/phone-call.png";
import TelegramIcon1 from "../assets/images/Telegram.svg";
import InstaIcon1 from "../assets/images/Instagram.svg";
import GamesSearchModal from "../views/components/GamesSearchModal";

import GooglePay from "../assets/images/payments/gpay.svg";
import MasterCard from "../assets/images/payments/mastercard_white.svg";
import PayTM from "../assets/images/payments/paytm.svg";
import PhonePe from "../assets/images/payments/phonepe.svg";
import NetBanking from "../assets/images/payments/netbanking.svg";
import UPI from "../assets/images/payments/upi.svg";
import Visa from "../assets/images/payments/visa.svg";

const footerPages = [
  "home",
  "sportsbook",
  "casino/evolution",
  "casino/ezugi",
  "gatewaylist",
];

const casinoProvidersGames = [
  {
    code: "evolution",
    name: "Evolution",
    imgUrl: ProviderLogo1,
    type: "evolution",
    status: 1,
  },
  {
    code: "ezugi",
    name: "Ezugi",
    imgUrl: ProviderLogo2,
    type: "ezugi",
    status: 2,
  },
  {
    code: "supernowa",
    name: "Supernowa",
    imgUrl: ProviderLogo3,
    type: "supernowa",
    status: 3,
  },
  {
    code: "xpg",
    name: "XPG",
    imgUrl: ProviderLogo4,
    type: "xpg",
    status: 4,
  },
  {
    code: "vivo",
    name: "Vivo",
    imgUrl: ProviderLogo5,
    type: "vivo",
    status: 5,
  },
  {
    code: "onetouch",
    name: "Onetouch",
    imgUrl: ProviderLogo7,
    type: "onetouch",
    status: 7,
  },
  {
    code: "pragmatic",
    name: "Pragmatic Play",
    imgUrl: ProviderLogo8,
    type: "pragmatic",
    status: 8,
  },
  {
    code: "onlyplay",
    name: "Only Play",
    imgUrl: ProviderLogo9,
    type: "onlyplay",
    status: 9,
  },
];

const Footer = () => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);
  const htmlElement = document.documentElement;
  useEffect(() => {
    const matchedValue = footerPages.find((f) =>
      location?.pathname.includes(f),
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  const handleToggleClick = () => {
    const realTimeValue = !showLeftbarToggle;
    if (!document.body.classList.contains("leftbat-opened")) {
      htmlElement.style.overflow = "auto";
      document.body.classList.add("leftbat-opened");
    } else {
      htmlElement.style.overflow = "auto";
      document.body.classList.remove("leftbat-opened");
    }
    setShowLeftbarToggle(realTimeValue);
  };

  return (
    <footer className="footer">
      <div className="inner-wrapper">
        <div className="FooterLinksSection">
          <div className="footerLinks foot-link">
            <h2 className="d-md-none">Legal & Safety</h2>
            <ul>
              <li>
                <a href="/promotion">Promotions</a>
              </li>
              <li>
                <a href="/referral">Refer a Friend</a>
              </li>
              <li>
                <a href="/contactus">Contact Us</a>
              </li>
              <li>
                <a href="/privacypolicy">Privacy Policy</a>
              </li>
              <li>
                <a href="/gamesrule">Games Rules</a>
              </li>
              <li>
                <a href="/fairplay">Fair Play</a>
              </li>
              <li>
                <a href="/responsiblegame">Responsible Gaming</a>
              </li>
              <li>
                <a href="/terms">Terms & Conditions</a>
              </li>
            </ul>
          </div>

          <div className="footerLinks">
            <h2>Join Our Community</h2>
            <ul>
              <li>
                <a href={`tel://${appDetails?.PHONE}`}>
                  <img src={Calling} alt="Whatsapp Icon" />
                </a>
              </li>
              <li>
                <a
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "#"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <img src={WhatsappIcon1} alt="Whatsapp Icon" />
                </a>
              </li>
              <li>
                <a
                  className="panel"
                  href={appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"}
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <img src={TelegramIcon} alt="Telegram Icon" />
                </a>
              </li>
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.INSTAGRAM != "" ? appDetails?.INSTAGRAM : "#"
                  }
                  target={appDetails?.INSTAGRAM != "" ? "_blank" : ""}
                >
                  <img src={InstaIcon} alt="Instagram Icon" />
                </a>
              </li>

              <li>
                <a
                  href={appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"}
                  target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                >
                  <img src={Facebook} alt="Email Icon" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="payment-partners">
          <h2>Our Payment Partners</h2>
          <ul>
            <li>
              <img src={GooglePay} alt="google pay" />
            </li>
            <li>
              <img src={MasterCard} alt="naster card" />
            </li>
            <li>
              <img src={PayTM} alt="paytm" />
            </li>
            <li>
              <img src={PhonePe} alt="phonepe" />
            </li>
            <li>
              <img src={NetBanking} alt="net banking" className="net" />
            </li>
            <li>
              <img src={UPI} alt="upi" />
            </li>
            <li>
              <img src={Visa} alt="visa" />
            </li>
          </ul>
        </div>

        <div className="copyright">
          <p>Copyright ©2026 Rudra333. ALL RIGHTS RESERVED.</p>
        </div>
      </div>

      <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 d-block d-lg-none">
        <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled">
          <li>
            <a
              className={activePage === "sportsbook" ? "active" : ""}
              onClick={() => handleToggleClick()}
              href="javascript:void(0)"
            >
              <img src={Menu} alt="sports" />
              <span>Menu</span>
            </a>
          </li>
          <li>
            <a href="#">
              {/* <img src={Chat} alt="aviator" /> */}
              <GamesSearchModal />
              <span>Explore</span>
            </a>
          </li>
          <li>
            <a
              className={activePage === "home" ? "active" : ""}
              href="/live-casino"
            >
              <img src={CasinoIcon} alt="home" />
              <span>Casino</span>
            </a>
          </li>
          <li>
            <a href="/exchange/Inplay">
              <img src={SportsIcon} alt="ezugi" />
              <span>Inplay</span>
            </a>
          </li>

          <Dropdown className="FooterDropdown">
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              <img src={Explore} alt="evolution" />
              <span>Support</span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <ul>
                <li>
                  <a href={`tel://${appDetails?.PHONE}`}>
                    <img src={Calling1} alt="Whatsapp Icon" />
                    <span>Call</span>
                  </a>
                </li>
                <li>
                  <a
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "#"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <img src={WhatsappIcon12} alt="Whatsapp Icon" />
                    <span>Whatsapp</span>
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"
                    }
                    target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                  >
                    <img src={TelegramIcon1} alt="Telegram Icon" />
                    <span>Telegram</span>
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.INSTAGRAM != "" ? appDetails?.INSTAGRAM : "#"
                    }
                    target={appDetails?.INSTAGRAM != "" ? "_blank" : ""}
                  >
                    <img src={InstaIcon1} alt="Instagram Icon" />
                    <span>Instagram</span>
                  </a>
                </li>

                <li>
                  <a
                    href={
                      appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"
                    }
                    target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                  >
                    <img src={Facebook1} alt="Email Icon" />
                    <span>Facebook</span>
                  </a>
                </li>
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
